import React from 'react';
import { cn } from '../../../lib/utils';
import { Input } from '../../../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { Search } from 'lucide-react';
import { UserFiltersProps } from '../types';

export function UserFilters({
  isDark,
  searchQuery,
  roleFilter,
  subscriptionFilter,
  deletionFilter,
  onSearch,
  onRoleFilter,
  onSubscriptionFilter,
  onDeletionFilter,
}: UserFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-3 flex-1 lg:flex-initial lg:max-w-3xl">
      <div className="relative flex-1">
        <Search className={cn(
          'absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4',
          isDark ? 'text-slate-500' : 'text-slate-400'
        )} />
        <Input
          type="text"
          placeholder="Поиск пользователей..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          className={cn(
            'pl-10 h-10 rounded-xl border-0',
            isDark 
              ? 'bg-slate-800 text-white placeholder:text-slate-500 focus:ring-[#C9A227]' 
              : 'bg-slate-100 text-slate-900 placeholder:text-slate-400 focus:ring-[#C9A227]'
          )}
        />
      </div>
      <Select value={roleFilter} onValueChange={onRoleFilter}>
        <SelectTrigger className={cn(
          'w-full sm:w-[140px] h-10 rounded-xl border-0',
          isDark 
            ? 'bg-slate-800 text-white' 
            : 'bg-slate-100 text-slate-900'
        )}>
          <SelectValue placeholder="Все роли" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Все роли</SelectItem>
          <SelectItem value="user">Пользователь</SelectItem>
          <SelectItem value="admin">Админ</SelectItem>
        </SelectContent>
      </Select>
      <Select value={subscriptionFilter} onValueChange={onSubscriptionFilter}>
        <SelectTrigger className={cn(
          'w-full sm:w-[160px] h-10 rounded-xl border-0',
          isDark 
            ? 'bg-slate-800 text-white' 
            : 'bg-slate-100 text-slate-900'
        )}>
          <SelectValue placeholder="Все статусы" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Все статусы</SelectItem>
          <SelectItem value="true">С подпиской</SelectItem>
          <SelectItem value="false">Бесплатный</SelectItem>
        </SelectContent>
      </Select>
      <Select value={deletionFilter} onValueChange={onDeletionFilter}>
        <SelectTrigger className={cn(
          'w-full sm:w-[170px] h-10 rounded-xl border-0',
          isDark
            ? 'bg-slate-800 text-white'
            : 'bg-slate-100 text-slate-900'
        )}>
          <SelectValue placeholder="Активные" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="false">Активные</SelectItem>
          <SelectItem value="true">Удалённые</SelectItem>
          <SelectItem value="all">Все аккаунты</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
